import { loginSchema } from './LoginValidationSchema';
import { loginUser } from '../../../reducers/auth/auth.actions';
import { ROOT } from '../../../constants/routes';
import { getLaravelValidationErrors } from '../../../helpers';

const formik = ({ dispatch, callback }) => {
  return {
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: loginSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      dispatch(loginUser(values))
        .then(resp => {
          callback();
        })
        .catch(errors => {
          console.log('Form errors', errors);
          setStatus({ errors: getLaravelValidationErrors(errors) });
          setSubmitting(false);
        });
    },
  };
};

export default formik;
